import modelBase from '../../models/model-base.model';
import { apiStatusCodes } from '../../config/global-variables';

var trainingImageModel = {

    getImage: function (successCallBack, failureCallBack, projectId, imageId) {
        var path = '/api/objectdetection/projects/' + projectId + '/images/' +  imageId;
        modelBase.get(successCallBack, failureCallBack, path, {});
    },

    getImagesList : function (successCallBack, failureCallBack, projectId, searchImageIds, pageIndex, pageSize) {
        var path = '/api/objectdetection/projects/' + projectId + '/images' + '?SearchImageIds=' + searchImageIds + '&PageIndex=' + pageIndex + '&PageSize=' + pageSize;
        modelBase.get(successCallBack, failureCallBack, path, {});
    },

    uploadNewImageWithTags: function (successCallBack, failureCallBack, projectId, inputDataModel) {

        if (inputDataModel.selectedFile == null) {
            let error = new Error();
            error.code = apiStatusCodes.badRequest;
            error.response = [];
            error.response.push({ code: "LT00000010XX", message: "Please pick an image from your computer first." });
            
            failureCallBack(error);

            return;
        }

        if (inputDataModel.assignedTags.length == 0) {
            let error = new Error();
            error.code = apiStatusCodes.badRequest;
            error.response = [];
            error.response.push({ code: "LT00000010XX", message: "Please at least assign a tag to the image." });
            
            failureCallBack(error);

            return;
        }

        // Limits and quotas for Custom Vision on Azure
        //
        // Reference: https://docs.microsoft.com/en-us/azure/cognitive-services/custom-vision-service/limits-and-quotas
        if (inputDataModel.imageWidth > 10240) {

            let error = new Error();
            error.code = apiStatusCodes.badRequest;
            error.response = [];
            error.response.push({ code: "LT00000010XX", message: "The maximum width of image is 10240 pixels. This image is too wide." });
            
            failureCallBack(error);

            return;
        } else if (inputDataModel.imageHeight > 10240) {

            let error = new Error();
            error.code = apiStatusCodes.badRequest;
            error.response = [];
            error.response.push({ code: "LT00000010XX", message: "The maximum height of image is 10240 pixels. This image is too tall." });
            
            failureCallBack(error);

            return;
        } else if (inputDataModel.imageWidth / inputDataModel.imageHeight > 25 || inputDataModel.imageHeight / inputDataModel.imageWidth > 25) {

            let error = new Error();
            error.code = apiStatusCodes.badRequest;
            error.response = [];
            error.response.push({ code: "LT00000010XX", message: "The ratio of image should not be larger than 25:1." });

            failureCallBack(error);

            return;
        }

        let formData = new FormData();

        let submittingAssignedTags = [];

        for(var i = 0; i < inputDataModel.assignedTags.length; i++) {
            
            var isTagAvailable = false;
            for (var j = 0; j < inputDataModel.availableTags.length; j++) {
                if (inputDataModel.availableTags[j].code == inputDataModel.assignedTags[i].tagId) {
                    isTagAvailable = true;
                    break;
                }
            }

            if (!isTagAvailable) {
                break;
            }

            submittingAssignedTags.push({
                tagId: inputDataModel.assignedTags[i].tagId, 
                tagName: inputDataModel.assignedTags[i].tagName, 
                width: inputDataModel.assignedTags[i].width, 
                height: inputDataModel.assignedTags[i].height, 
                top: inputDataModel.assignedTags[i].top, 
                left: inputDataModel.assignedTags[i].left, 
            });
        }

        formData.append('file', inputDataModel.selectedFile);
        formData.append('tags', JSON.stringify(submittingAssignedTags));

        var path = '/api/objectdetection/projects/' + projectId + '/images';
        modelBase.post(successCallBack, failureCallBack, path, { body: formData });
    },

    updateImageWithTags: function (successCallBack, failureCallBack, projectId, inputDataModel) {        

        if (inputDataModel.assignedTags.length == 0) {
            let error = new Error();
            error.code = apiStatusCodes.badRequest;
            error.response = [];
            error.response.push({ code: "LT00000010XX", message: "Please at least assign a tag to the image." });
            
            failureCallBack(error);

            return;
        }

        // Limits and quotas for Custom Vision on Azure
        //
        // Reference: https://docs.microsoft.com/en-us/azure/cognitive-services/custom-vision-service/limits-and-quotas
        if (inputDataModel.imageWidth > 10240) {

            let error = new Error();
            error.code = apiStatusCodes.badRequest;
            error.response = [];
            error.response.push({ code: "LT00000010XX", message: "The maximum width of image is 10240 pixels. This image is too wide." });
            
            failureCallBack(error);

            return;
        } else if (inputDataModel.imageHeight > 10240) {

            let error = new Error();
            error.code = apiStatusCodes.badRequest;
            error.response = [];
            error.response.push({ code: "LT00000010XX", message: "The maximum height of image is 10240 pixels. This image is too tall." });
            
            failureCallBack(error);

            return;
        } else if (inputDataModel.imageWidth / inputDataModel.imageHeight > 25 || inputDataModel.imageHeight / inputDataModel.imageWidth > 25) {

            let error = new Error();
            error.code = apiStatusCodes.badRequest;
            error.response = [];
            error.response.push({ code: "LT00000010XX", message: "The ratio of image should not be larger than 25:1." });

            failureCallBack(error);

            return;
        }

        let formData = new FormData();

        let submittingAssignedTags = [];

        for(var i = 0; i < inputDataModel.assignedTags.length; i++) {
            var isTagAvailable = false;
            for (var j = 0; j < inputDataModel.availableTags.length; j++) {
                if (inputDataModel.availableTags[j].code == inputDataModel.assignedTags[i].tagId) {
                    isTagAvailable = true;
                    break;
                }
            }

            if (!isTagAvailable) {
                break;
            }

            submittingAssignedTags.push({
                tagId: inputDataModel.assignedTags[i].tagId, 
                tagName: inputDataModel.assignedTags[i].tagName, 
                width: inputDataModel.assignedTags[i].width, 
                height: inputDataModel.assignedTags[i].height, 
                top: inputDataModel.assignedTags[i].top, 
                left: inputDataModel.assignedTags[i].left, 
            });
        }

        formData.append('file', inputDataModel.selectedFile);
        formData.append('fileId', inputDataModel.selectedFileId);
        formData.append('tags', JSON.stringify(submittingAssignedTags));

        var path = '/api/objectdetection/projects/' + projectId + '/images/' + inputDataModel.selectedImageId;
        modelBase.post(successCallBack, failureCallBack, path, { body: formData });
    },

    deactivateImage: function (successCallBack, failureCallBack, projectId, imageId) {
        var path = '/api/objectdetection/projects/' + projectId + '/images/' + imageId + '/deactivate';
        modelBase.post(successCallBack, failureCallBack, path, {});
    },

}




export default trainingImageModel
